(function () {
  var root = document.querySelector('.pdp');
  if (!root) return;

  function ga(name, params) {
    if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
  }

  var pageLoad = Date.now();
  function secs() { return Math.round((Date.now() - pageLoad) / 1000); }
  function money(n) { return '$' + n; }

  var track = root.querySelector('[data-gallery-track]');
  var thumbs = [].slice.call(root.querySelectorAll('[data-gallery-thumb]'));
  if (track && thumbs.length) {
    var syncThumbs = function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      root.querySelectorAll('.pdp__thumb').forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
      });
    };
    track.addEventListener('scroll', syncThumbs, { passive: true });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var n = parseInt(t.getAttribute('data-gallery-thumb'), 10);
        track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
      });
    });
    syncThumbs();
  }


  var notify = root.querySelector('[data-notify]');
  var notifyOpenBtn = root.querySelector('[data-notify-open]');
  if (notify && notifyOpenBtn) {
    ga('view_item_out_of_stock', {
      item_id: root.getAttribute('data-product-sku') || '',
      item_name: root.getAttribute('data-product-title') || '',
      product_handle: root.getAttribute('data-product-handle') || ''
    });
    var NOTIFY_URL = (document.documentElement.getAttribute('data-api') || 'https://front.4147r3yu.com').replace(/\/+$/, '') + '/api/notify';
    var notifyRenderedAt = Date.now();
    var notifyForm = notify.querySelector('[data-notify-form]');
    var notifyEmail = notifyForm.querySelector('input[type="email"]');
    var notifyHp = notifyForm.querySelector('input[name="website"]');
    var notifyErr = notify.querySelector('[data-notify-error]');
    var notifySubmit = notify.querySelector('[data-notify-submit]');
    var notifyDone = notify.querySelector('[data-notify-done]');
    var notifyBusy = false;
    var notifyHint = notify.querySelector('[data-notify-hint]');
    var notifyHintEmail = notify.querySelector('[data-notify-hint-email]');
    var notifyHintYes = notify.querySelector('[data-notify-hint-yes]');
    var notifyHintNo = notify.querySelector('[data-notify-hint-no]');
    var KNOWN_DOMAINS = ['gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'icloud.com',
      'aol.com', 'live.com', 'me.com', 'mac.com', 'msn.com', 'comcast.net', 'att.net',
      'verizon.net', 'sbcglobal.net', 'protonmail.com', 'proton.me', 'ymail.com',
      'googlemail.com', 'hey.com', 'mail.com', 'gmx.com', 'gmx.de', 'web.de',
      'yahoo.co.uk', 'hotmail.co.uk', 'outlook.co.uk', 'live.co.uk', 'live.ca', 'yahoo.ca',
      'hotmail.fr', 'hotmail.de', 'hotmail.es', 'hotmail.it', 'yahoo.fr', 'yahoo.de', 'yahoo.es',
      'yahoo.it', 'outlook.fr', 'outlook.de', 'outlook.es'];
    var editDistance = function (a, b) {
      var prev = [], cur, i, j;
      for (j = 0; j <= b.length; j++) prev[j] = j;
      for (i = 1; i <= a.length; i++) {
        cur = [i];
        for (j = 1; j <= b.length; j++) {
          cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        }
        prev = cur;
      }
      return prev[b.length];
    };
    var suggestEmail = function (email) {
      var at = email.lastIndexOf('@');
      if (at < 1) return '';
      var local = email.slice(0, at), domain = email.slice(at + 1).toLowerCase();
      if (KNOWN_DOMAINS.indexOf(domain) !== -1) return '';
      var best = '', bestD = 3;
      KNOWN_DOMAINS.forEach(function (k) {
        var d = editDistance(domain, k);
        if (d < bestD) { bestD = d; best = k; }
      });
      return best ? local + '@' + best : '';
    };
    var notifyHintSeenFor = '';
    var hideNotifyHint = function () {
      if (!notifyHint) return;
      notifyHint.hidden = true;
      notifySubmit.hidden = false;
    };
    var showNotifyHint = function (suggestion) {
      notifyHintEmail.textContent = suggestion;
      notifyHint.hidden = false;
      notifySubmit.hidden = true;
    };

    var openNotify = function () {
      notify.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      ga('restock_notify_open', { product_handle: notify.getAttribute('data-notify-handle') || '' });
      if (!notifyDone.hidden) return;
      setTimeout(function () { notifyEmail.focus(); }, 50);
    };
    var closeNotify = function () {
      notify.hidden = true;
      document.documentElement.style.overflow = '';
      notifyOpenBtn.focus();
    };
    var showNotifyError = function (msg) {
      notifyErr.textContent = msg;
      notifyErr.hidden = false;
    };

    notifyOpenBtn.addEventListener('click', openNotify);
    if (location.hash === '#notify') openNotify();
    notify.querySelectorAll('[data-notify-close]').forEach(function (b) { b.addEventListener('click', closeNotify); });
    notify.addEventListener('click', function (e) { if (e.target === notify) closeNotify(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !notify.hidden) closeNotify(); });
    if (notifyHint) {
      notifyHintYes.addEventListener('click', function () {
        notifyEmail.value = notifyHintEmail.textContent;
        hideNotifyHint();
        notifyForm.requestSubmit ? notifyForm.requestSubmit() : notifyForm.dispatchEvent(new Event('submit', { cancelable: true }));
      });
      notifyHintNo.addEventListener('click', function () {
        notifyHintSeenFor = notifyEmail.value.trim().toLowerCase();
        hideNotifyHint();
        notifyEmail.focus();
      });
      notifyEmail.addEventListener('input', hideNotifyHint);
    }

    notifyForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (notifyBusy) return;
      notifyErr.hidden = true;
      var email = notifyEmail.value.trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showNotifyError('Enter a valid email address.');
        notifyEmail.focus();
        return;
      }
      if (notifyHint) {
        var suggestion = suggestEmail(email);
        if (suggestion && email.toLowerCase() !== notifyHintSeenFor) {
          notifyHintSeenFor = email.toLowerCase();
          showNotifyHint(suggestion);
          return;
        }
        hideNotifyHint();
      }
      notifyBusy = true;
      notifySubmit.disabled = true;
      notifySubmit.textContent = 'Sending';
      fetch(NOTIFY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email,
          sku: notify.getAttribute('data-notify-sku') || '',
          handle: notify.getAttribute('data-notify-handle') || '',
          product_id: notify.getAttribute('data-notify-product-id') || '',
          rendered_at: notifyRenderedAt,
          website: notifyHp ? notifyHp.value : ''
        })
      })
        .then(function (res) {
          if (res.status === 429) { var er = new Error('Too many requests in a row. Wait a moment and try again.'); er.userMessage = true; throw er; }
          return res.json().catch(function () { return {}; }).then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (r) {
          if (r.ok && r.data && r.data.success) {
            notifyEmail.disabled = true;
            notifySubmit.textContent = 'Success';
            notifySubmit.disabled = true;
            notifyDone.hidden = false;
            notifyOpenBtn.textContent = 'Success';
            notifyOpenBtn.disabled = true;
            ga('restock_notify_submitted', { product_handle: notify.getAttribute('data-notify-handle') || '' });
          } else {
            showNotifyError((r.data && r.data.error) || 'Something went wrong. Try again.');
          }
        })
        .catch(function (err) {
          showNotifyError(err && err.userMessage ? err.message : 'Something went wrong. Try again.');
        })
        .then(function () {
          notifyBusy = false;
          if (!notifyDone.hidden) return;
          notifySubmit.disabled = false;
          notifySubmit.textContent = 'Notify me';
        });
    });
  }

  var bar = root.querySelector('[data-sticky-cta]');
  if (bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-stuck', entries[0].intersectionRatio < 1);
    }, { threshold: [1], rootMargin: '0px 0px -1px 0px' }).observe(bar);
  }

  var tabsRoot = root.querySelector('[data-tabs]');
  if (tabsRoot) {
    var tabBtns = Array.prototype.slice.call(tabsRoot.querySelectorAll('[role="tab"]'));
    var selectTab = function (btn, focus) {
      tabBtns.forEach(function (b) {
        var on = b === btn;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(b.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) btn.focus();
    };
    var swipeX = null, swipeY = null;
    var currentTab = function () {
      for (var k = 0; k < tabBtns.length; k++) if (tabBtns[k].getAttribute('aria-selected') === 'true') return k;
      return 0;
    };
    var stepTab = function (dir) {
      var n = currentTab() + dir;
      if (n < 0 || n >= tabBtns.length) return;
      selectTab(tabBtns[n], false);
      ga('pdp_tab_selected', { tab: tabBtns[n].getAttribute('data-tab'), item_id: root.getAttribute('data-product-id'), via: 'swipe' });
    };
    tabsRoot.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { swipeX = null; return; }
      swipeX = e.touches[0].clientX; swipeY = e.touches[0].clientY;
    }, { passive: true });
    tabsRoot.addEventListener('touchend', function (e) {
      if (swipeX === null || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - swipeX;
      var dy = e.changedTouches[0].clientY - swipeY;
      swipeX = null;
      if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      stepTab(dx < 0 ? 1 : -1);
    }, { passive: true });

    tabBtns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-selected') === 'true') return;
        selectTab(b, false);
        ga('pdp_tab_selected', { tab: b.getAttribute('data-tab'), item_id: root.getAttribute('data-product-id') });
      });
      b.addEventListener('keydown', function (e) {
        var n;
        if (e.key === 'ArrowRight') n = i + 1;
        else if (e.key === 'ArrowLeft') n = i - 1;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = tabBtns.length - 1;
        else return;
        e.preventDefault();
        n = (n + tabBtns.length) % tabBtns.length;
        selectTab(tabBtns[n], true);
        ga('pdp_tab_selected', { tab: tabBtns[n].getAttribute('data-tab'), item_id: root.getAttribute('data-product-id') });
      });
    });
  }

  var reviewsAcc = root.querySelector('[data-acc="reviews"]');
  var reviewList = root.querySelector('[data-reviews]');
  var reviewTools = root.querySelector('[data-review-tools]');
  var moreBtn = root.querySelector('[data-reviews-more]');
  var jump = root.querySelector('[data-reviews-jump]');

  if (jump && reviewsAcc) {
    jump.addEventListener('click', function () {
      reviewsAcc.open = true;
      reviewsAcc.scrollIntoView({ block: 'start' });
      ga('reviews_open', { source: 'buy_box', item_id: root.getAttribute('data-product-id') });
      loadReviews();
    });
  }

  var allReviews = null;
  var loading = false;
  var ratingFilter = 0;
  var query = '';
  var PAGE = 10;
  var visible = PAGE;
  var pageBtn = null;

  function starMarkup(rating) {
    var wrap = document.createElement('span');
    wrap.className = 'al-stars';
    var glyphs = document.createElement('span');
    glyphs.className = 'al-stars__glyphs';
    glyphs.setAttribute('role', 'img');
    glyphs.setAttribute('aria-label', rating + ' out of 5 stars');
    var base = document.createElement('span');
    base.className = 'al-stars__base';
    base.textContent = '\u2605\u2605\u2605\u2605\u2605';
    var fill = document.createElement('span');
    fill.className = 'al-stars__fill';
    fill.textContent = '\u2605\u2605\u2605\u2605\u2605';
    fill.style.width = (rating / 5) * 100 + '%';
    glyphs.appendChild(base);
    glyphs.appendChild(fill);
    wrap.appendChild(glyphs);
    return wrap;
  }

  function reviewCard(r) {
    var card = document.createElement('div');
    card.className = 'al-review' + (r.body ? '' : ' al-review--starsonly');

    var head = document.createElement('div');
    head.className = 'al-review__head';
    var name = document.createElement('span');
    name.className = 'al-review__name';
    var author = (r.author || '').trim();
    name.textContent = (!author || /^(verified buyer|anonymous)$/i.test(author)) ? 'Anonymous' : author;
    if (r.verified) {
      var v = document.createElement('span');
      v.className = 'al-review__verified';
      v.textContent = ' Verified';
      name.appendChild(v);
    }
    var date = document.createElement('span');
    date.className = 'al-review__date';
    date.textContent = formatMonth(r.created_at);
    head.appendChild(name);
    head.appendChild(date);

    var stars = document.createElement('div');
    stars.className = 'al-review__stars';
    stars.appendChild(starMarkup(r.rating));

    card.appendChild(head);
    card.appendChild(stars);
    if (r.body) {
      var body = document.createElement('p');
      body.className = 'al-review__body';
      body.textContent = r.body;
      card.appendChild(body);
    }
    return card;
  }

  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function formatMonth(iso) {
    var p = String(iso || '').split('-');
    if (p.length < 2) return '';
    return MONTHS[parseInt(p[1], 10) - 1] + ' ' + p[0];
  }

  function matches(r) {
    if (ratingFilter && r.rating !== ratingFilter) return false;
    if (!query) return true;
    var hay = (r.body + ' ' + r.title + ' ' + r.author).toLowerCase();
    return hay.indexOf(query) !== -1;
  }

  function syncHistogram() {
    if (!allReviews) return;
    var counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    allReviews.forEach(function (r) { counts[r.rating]++; });
    var denom = allReviews.length || 1;
    root.querySelectorAll('[data-rating-filter]').forEach(function (row) {
      var n = counts[parseInt(row.getAttribute('data-rating-filter'), 10)] || 0;
      row.querySelector('.al-rsum__count').textContent = n;
      row.querySelector('.al-rsum__fill').style.width = (n / denom) * 100 + '%';
    });
    var n = allReviews.length;
    var label = n + ' review' + (n === 1 ? '' : 's');

    var footCount = root.querySelector('[data-agg-count]');
    if (footCount) footCount.textContent = label;

    var sum = allReviews.reduce(function (a, r) { return a + r.rating; }, 0);
    var avg = n ? (sum / n).toFixed(2) : '0';

    var bigScore = root.querySelector('.al-rsum__avg');
    if (bigScore) {
      bigScore.textContent = avg;
      var outOf = document.createElement('span');
      outOf.className = 'al-rsum__outof';
      outOf.textContent = '/5';
      bigScore.appendChild(outOf);
    }
  }

  function pageButton() {
    if (pageBtn) return pageBtn;
    var wrap = document.createElement('div');
    wrap.className = 'al-reviews__more';
    pageBtn = document.createElement('button');
    pageBtn.type = 'button';
    pageBtn.className = 'al-btn al-btn--secondary al-btn--full';
    pageBtn.addEventListener('click', function () {
      visible += PAGE;
      renderReviews(true);
      ga('reviews_show_more', { item_id: root.getAttribute('data-product-id'), shown: visible });
    });
    wrap.appendChild(pageBtn);
    reviewList.parentNode.insertBefore(wrap, reviewList.nextSibling);
    return pageBtn;
  }

  function renderReviews(keepPage) {
    if (!allReviews) return;
    if (keepPage !== true) visible = PAGE;
    var shown = allReviews.filter(matches);
    reviewList.textContent = '';
    var frag = document.createDocumentFragment();
    shown.slice(0, visible).forEach(function (r) { frag.appendChild(reviewCard(r)); });
    reviewList.appendChild(frag);

    var left = shown.length - visible;
    var btn = pageButton();
    btn.parentNode.hidden = left <= 0;
    if (left > 0) {
      var next = Math.min(PAGE, left);
      btn.textContent = 'Show ' + next + ' more ' + (next === 1 ? 'review' : 'reviews');
    }

    var counter = root.querySelector('[data-review-count]');
    if (counter) {
      counter.textContent = shown.length === allReviews.length
        ? ''
        : shown.length + ' of ' + allReviews.length + ' reviews';
    }
    root.querySelectorAll('[data-rating-filter]').forEach(function (row) {
      var on = parseInt(row.getAttribute('data-rating-filter'), 10) === ratingFilter;
      row.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function loadReviews() {
    if (allReviews || loading || !reviewList) return Promise.resolve();
    var base = reviewList.getAttribute('data-review-api');
    var handle = reviewList.getAttribute('data-review-handle');
    if (!base || !handle) return Promise.resolve();

    loading = true;
    if (moreBtn) moreBtn.textContent = 'Loading reviews...';

    return fetch(base + encodeURIComponent(handle), { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (data) {
        allReviews = data.reviews || [];
        if (reviewTools) reviewTools.hidden = false;
        if (moreBtn && moreBtn.parentNode) moreBtn.parentNode.removeChild(moreBtn);
        syncHistogram();
        renderReviews();
        ga('reviews_show_all', { item_id: root.getAttribute('data-product-id'), count: allReviews.length });
      })
      .catch(function () {
        if (moreBtn) moreBtn.textContent = 'Reviews could not load. Try again.';
        loading = false;
      });
  }

  if (moreBtn) moreBtn.addEventListener('click', loadReviews);
  if (reviewsAcc) {
    reviewsAcc.addEventListener('toggle', function () {
      if (reviewsAcc.open) loadReviews();
    });
  }

  var searchInput = root.querySelector('[data-review-search]');
  if (searchInput) {
    var searchTimer, searchGaTimer;
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      clearTimeout(searchGaTimer);
      searchTimer = setTimeout(function () {
        query = searchInput.value.trim().toLowerCase();
        renderReviews();
      }, 150);
      searchGaTimer = setTimeout(function () {
        var q = searchInput.value.trim().toLowerCase();
        if (!q) return;
        var term = q.replace(/\S+@\S+/g, '[email]').replace(/\d{3,}/g, '[n]').slice(0, 40);
        ga('reviews_search', { search_term: term, query_length: q.length });
      }, 800);
    });
  }

  root.querySelectorAll('[data-rating-filter]').forEach(function (row) {
    row.addEventListener('click', function () {
      var stars = parseInt(row.getAttribute('data-rating-filter'), 10);
      ratingFilter = (ratingFilter === stars) ? 0 : stars;
      if (!allReviews) { loadReviews().then(renderReviews); return; }
      renderReviews();
      ga('reviews_filter', { filter: ratingFilter || 'all' });
    });
  });

  var drawer = document.getElementById('pdp-pwyc');
  var dataEl = document.getElementById('pdp-pwyc-data');
  var variantInput = document.getElementById('pdp-variant-id');
  var form = document.getElementById('pdp-form');
  var openBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pwyc-open]'));

  if (drawer && dataEl && variantInput && window.AlatreyuPWYC) {
    var pwyc = JSON.parse(dataEl.textContent);
    var lastOpener = null;
    var priceRowEl = document.getElementById('pdp-price');
    var priceLabelEl = document.querySelector('[data-price-label]');
    var pwycDrawer = window.AlatreyuPWYC.bind(drawer, pwyc, {
      secs: secs,
      handle: root.getAttribute('data-product-handle') || '',
      sku: root.getAttribute('data-product-sku') || '',
      title: root.getAttribute('data-product-title') || '',
      onApply: function (v, id) {
        variantInput.value = id;
        if (priceRowEl) priceRowEl.textContent = money(v);
        if (priceLabelEl) {
          priceLabelEl.textContent = (v === pwyc.anchor)
            ? priceLabelEl.getAttribute('data-label-suggested')
            : priceLabelEl.getAttribute('data-label-chosen');
        }
      },
      add: form ? function (id) {
        variantInput.value = id;
        pwycDrawer.close();
        if (window.AlatreyuCart) return window.AlatreyuCart.add(form);
        form.submit();
      } : null,
      onClose: function () { if (lastOpener && document.contains(lastOpener)) lastOpener.focus({ preventScroll: true }); }
    });
    openBtns.forEach(function (b) { b.addEventListener('click', function () { lastOpener = b; pwycDrawer.open(); }); });
  } else {
    openBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        ga('cost_transparency_opened', {
          product_handle: root.getAttribute('data-product-handle') || '',
          seconds_on_page: secs()
        });
      });
    });
  }
})();
